export default {
  app: {
    orgCode: 'แปลเป็นภาษาไทยคือ "รหัสกลุ่ม/แบรนด์',
    orgCodePlaceholder: "แปลเป็นภาษาไทยคือ",
    username: "บัญชี",
    usernamePlaceholder: "กรุณาใส่ชื่อผู้ใช้",
    password: "รหัสผ่าน",
    passwordPlaceholder: "กรุณาใส่รหัสผ่าน",
    captcha: "รหัสยืนยัน",
    captchaPlaceholder: "กรุณากรอกรหัสยืนยัน",
    captchaExpired: "กรุณารีเฟรชรหัสยืนยัน",
    login: "เข้าสู่ระบบ",
    remember: "จดจำข้อมูลการเข้าสู่ระบบ",
    switchPC: "เปลี่ยนไปที่แบ็กเอนด์",
    mobileVersion: "BI มือถือ",
    desktopVersion: "Backend ผู้ค้า",
    setupPassword: "ตั้งรหัสผ่าน",
    newPassword: "รหัสผ่านใหม่",
    newPasswordPlaceholder: "กรุณากรอกรหัสผ่านใหม่",
    retypePassword: "ป้อนรหัสผ่านใหม่อีกครั้ง",
    retypePasswordPlaceholder: "กรุณากรอกรหัสผ่านใหม่อีกครั้ง",
    setupPasswordRule: "รหัสผ่านต้องมีความยาว 6-32 ตัวอักษร และต้องมีอย่างน้อยสองอย่างต่อไปนี้: ตัวเลข ตัวอักษร สัญลักษณ์。",
    setupPasswordRuleRefer: "รหัสผ่านจะต้องมีอักขระ 6-32 ตัวและมีตัวเลข ตัวอักษร และสัญลักษณ์รวมกันมากกว่า 2 ชุด กรุณาป้อนใหม่",
    setupPasswordOk: "แน่นอน",
    setupPasswordDiffer: "รหัสผ่านที่ป้อนสองครั้งไม่สอดคล้องกัน โปรดป้อนใหม่",
    err_def: "การเข้าสู่ระบบล้มเหลว กรุณารีเฟรชหน้าและลองอีกครั้ง",
    err_2000: "รหัสยืนยันไม่ถูกต้อง",
    err_2010: "ข้อมูลการเข้าสู่ระบบที่ป้อนไม่ถูกต้อง",
    err_4001: "บัญชีนี้ไม่ได้รับอนุญาตสำหรับการทำงานใดๆ",
    err_4011: "ร้านถูกปิดใช้งาน ไม่สามารถเข้าสู่ระบบได้",
    err_4012: "แฟรนไชส์ถูกปิดใช้งาน ไม่สามารถเข้าสู่ระบบได้",
    err_4013: "แบรนด์ถูกปิดใช้งาน ไม่สามารถเข้าสู่ระบบได้",
    err_4014: "กลุ่มถูกปิดใช้งาน ไม่สามารถเข้าสู่ระบบได้",
    err_4015: "พื้นที่ถูกปิดใช้งานและไม่สามารถเข้าสู่ระบบได้",
    err_4401: "บัญชีนี้ไม่ได้รับอนุญาตสำหรับร้านค้านี้",
    err_4402: "บัญชีนี้ไม่มีสิทธิ์ผู้ดูแลระบบและไม่สามารถรับรหัสยืนยันได้",
    err_5001: "การตั้งค่ารหัสผ่านล้มเหลว โปรดลองอีกครั้ง",
  },
  verifyRefund: {
    title: "คำขอคืนสินค้า",
    hint: "โปรดตรวจสอบข้อมูลการคืนสินค้าก่อนให้รหัสยืนยัน",
    verifyCode: "รหัสยืนยัน",
    copy: "คัดลอก",
    copySucceed: "คัดลอกสำเร็จ",
    copyFailed: "คัดลอกไม่สำเร็จ",
    expireTime: "เวลาหมดอายุ",
    shop: "ร้านค้า",
    soTime: "เวลาสั่งซื้อ",
    soNo: "หมายเลขคำสั่งซื้อ POS",
    amount: "จำนวนเงินคืน",
  },
}